import { Phone, Video } from "react-feather";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { setActiveContactUser } from "../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import { dynamicImage, Image } from "../../../../../Utils";

const ContactTab = () => {
  const dispatch = useAppDispatch();
  const { activeContactUser } = useAppSelector((state) => state.messenger);
  return (
    <ul className="contact-log-main">
      {activeContactUser.map((item, index) => (
        <li key={index} className={item.active ? "active" : ""} onClick={() => dispatch(setActiveContactUser(index))}>
          <div className="contact-box">
            <div className={`profile ${item.onlineStatus}`}>
              <Image className="bg-img" src={dynamicImage(`contact/${item.avatar}.jpg`)} alt="Avatar" />
            </div>
            <div className="details">
              <h4>{item.userName}</h4>
              <h5>{item.number}</h5>
            </div>
            <div className="contact-action">
              <div className="icon-btn btn-outline-primary btn-sm button-effect">
                <Phone />
              </div>
              <div className="icon-btn btn-outline-success btn-sm button-effect">
                <Video />
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default ContactTab;
